import React, { useEffect, useState } from 'react';
import Page from '@Containers/Page';
import { HashRouter as Router, Switch, useLocation } from 'react-router-dom';
import ConnectedRoute from '@AppRoutes/ConnectedRoute';
import Footer from '@Components/Footer';
import HeaderContainer from '@Pages/History/HeaderContainer';
import { paths } from '@AppRoutes/constants';
import NewRelicService from '@Services/NewRelicService';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import HistoryRecent from './HistoryRecent';
import HistorySaved from './HistorySaved';

import './History.theme.scss';
import './HistoryModal.theme.scss';
import './History.custom.scss';

export default function HistoryContainer() {
  const location = useLocation();
  const [currentLocation, setCurrentLocation] = useState(location);

  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    setCurrentLocation(location);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (currentLocation !== location) {
      NewRelicService.trackRouteChanges(location.pathname);
    }
    RouteChangeTracking.handleSkipLinkFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Page withFooter={false}>
      <div id="history" className="results-wrapper history-main-wrapper">
        <main id="main-content" className="results-wrapper-inner" aria-labelledby="history-title">
          <HeaderContainer />
          <section className="history-page left-gutter right-gutter rx-list-wrapper">
            <Router>
              <Switch>
                <ConnectedRoute path={paths.HISTORY_RECENT} render={() => <HistoryRecent />} />
                <ConnectedRoute path={paths.HISTORY_SAVED} render={() => <HistorySaved />} />
              </Switch>
            </Router>
          </section>
        </main>
        <Footer />
      </div>
    </Page>
  );
}
